module.exports = "<lfwms-searchable-entity-search [serviceFactory]=\"serviceFactory\"></lfwms-searchable-entity-search>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/maintain-report/maintain-report-home/maintain-report-search/maintain-report-search.component.html
// module id = ../../../../../src/app/features/reports/maintain-report/maintain-report-home/maintain-report-search/maintain-report-search.component.html
// module chunks = main